import httpClient from "../http/http-client";
import { IGroup, IGroupDetail, IGroupWithCategory } from './group.model';

export default class GroupService {
  http;
  groups?: IGroup[];
  taggedGroups?: IGroup[]
  groupsWithCategories?: IGroupWithCategory[];

  static instance = new GroupService();

  static getInstance() {
    if (GroupService.instance === null) GroupService.instance = new GroupService();
    return this.instance;
  }

  constructor() {
    this.http = httpClient
  }

  async getGroups(forceUpdate: boolean = false): Promise<IGroup[]> {
    if (this.groups && !forceUpdate) {
      return Promise.resolve(this.groups);
    } else {
      return this.http.get(`group`)
        .then(response => {
          this.groups = response.data;
          this.taggedGroups = response.data.filter((group: IGroup) => group.isTagged)
          return response.data;
        })
        .catch(err => {
          console.log(err);
          throw err;
        })
    }
  }

  async getTaggedGroups(forceUpdate: boolean = false): Promise<IGroup[]> {
    if (this.taggedGroups && !forceUpdate) {
      return Promise.resolve(this.taggedGroups);
    } else {
      return this.http.get(`group`)
        .then(response => {
          this.groups = response.data;
          this.taggedGroups = response.data.filter((group: IGroup) => group.isTagged)
          return response.data.filter((group: IGroup) => group.isTagged);
        })
        .catch(err => {
          console.log(err);
          throw err;
        })
    }
  }

  async getGroupsWithCategories(forceUpdate: boolean = false, queryString?: string,): Promise<IGroupWithCategory[]> {
    if (this.groupsWithCategories && !forceUpdate) {
      return Promise.resolve(this.groupsWithCategories);
    } else {
      return this.http.get(`group/categories${queryString ? queryString : ''}`)
        .then(response => {
          return response.data;
        })
        .catch(err => {
          console.log(err);
          throw err;
        })
    }
  }

  async getGroupsByCategory(categoryId: string): Promise<IGroup[]> {
    return this.http.get(`group/by-category/${categoryId}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getGroupsAndActionInfoForReportPeriod(reportPeriodId: string): Promise<IGroup[]> {
    return this.http.get(`group/actions?reportPeriodId=${reportPeriodId}`)
      .then(response => {
        return response.data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getGroupWithActionsForReportPeriodWithPagination(id: string, reportPeriodId: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc', status?: string,): Promise<IGroupDetail> {
    return this.http.get(`group/actions/${id}?reportPeriodId=${reportPeriodId}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}${status ? `&status=${status}` : ''}`)
      .then((response: any) => {
        return response.data
      })
      .catch(err => {
        console.log(err)
      });
  }

  clearData() {
    this.groups = undefined;
    this.taggedGroups = undefined;
    this.groupsWithCategories = undefined
  }

}